import {segment} from './helpers'
import * as analytics from '../analytics'

export const lookNameModalViewed = () => segment('Dashboard Viewed Look Name Modal')
export const sessionExpired = () => segment('Expired User Session')

/**
 * A helper function used in the `TrackLink` component. We prefer to set the
 * event name explicitly per function now, so please favor a new function
 * creation over usage of this one.
 *
 * @param {String} location Description of where the link lives on the page
 * @param {String} target A URL, typically, of where the link is going
 * @param {String} eventName The name of the event to send to Segment
 * @deprecated
 * @todo Refactor the `TrackLink` component's use
 */
export const trackLink = (location, target, eventName) =>
  segment(eventName, {
    location,
    target,
  })

/**
 * A generic event used to indicate when a user clicks a link or button that is
 * acting sort of like a link. Utilize the `location` and `text` properties to
 * differentiate clicks on links in similar areas.
 *
 * @param {Object} props
 * @param {string} [props.location] Description of where the link lives on the page
 * @param {string} [props.text] The text content of the link
 * @param {string|undefined} [props.target] The URL of the link, if applicable
 * @param {string|undefined} [props.type] One of `button` or `link`, where `button` indicates the
 * user is not linked out to another route, while `link` indicates the user is linked out
 * to another route.
 */
export const clickedLink = ({location, text, target = '', type = 'link'}) =>
  segment('Clicked Link', {location, target, text, type})

// Segment Page View

// Page views should only be fired if the page is visible
// If the page is not visible, add a listener to see if it becomes visible

let segmentPageViewFired = false
const fireSegmentPageView = () => {
  segmentPageViewFired = true
  analytics.trackPage(window.location.pathname)
}

export const pageView = () => {
  if (!document.hidden) {
    fireSegmentPageView()
  } else {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && !segmentPageViewFired) {
        fireSegmentPageView()
      }
    })
  }
}
